export function GetWarehouseDescription(warehouse) {
    if (warehouse === 1)
        return "Mexico"
    else if (warehouse ===2)
        return "USA"
    else
        return null
}